import { useEffect, useRef } from "react";

/**
 * Helper hook to produce ref value that indicates whether the current
 * component is mounted or not. This value is meant for preventing state
 * updates from events that come while the component is not mounted.
 */
export function useIsMountedRef() {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
